module.exports = __webpack_public_path__ + "img/20200122.6d8bbe9a.png";